import { Modal } from "antd";
import { Trans, useTranslation } from "react-i18next";
import imgAnnoDominiWeb from "shared/assets/images/anno-domini-logo-stage-bg.png";
import imgAnnoDominiLogo from "shared/assets/images/anno-domini-logo.png";
import { formatNoSignObject, signByCurrency } from "shared/helpers/BRLFormat";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { createNewCashAdvance } from "shared/service/StrmService";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";
import "explorer/pages/new-estagio-artista/campanhas-especiais/CampanhasEspeciais.scss";
import "./ModalCampaignAD.scss";
import { isMobile } from "react-device-detect";

interface ModalCampaignADEligibleProps {
  open: boolean;
  onCancel: () => void;
}

const ModalCampaignADEligible: React.FC<ModalCampaignADEligibleProps> = (
  props
) => {
  const { open, onCancel } = props;
  const { t } = useTranslation();
  const { userArtist } = useSelector((state: any) => state.artists);
  const { loggedUser } = useSelector((state: any) => state.users);
  const history = useHistory();

  const acceptWithoutAdvance = () => {
    history.push("/distribua", {
      specialCampaign: SpecialCampaignEnum.AnnoDomini,
    });
  };

  const acceptWithAdvance = async () => {
    await createNewCashAdvance(loggedUser.id, SpecialCampaignEnum.AnnoDomini);
    history.push("/adiantamentos");
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onCancel}
      width={600}
      title={null}
      closable={true}
      maskClosable={false}
      className={`modal-campanha-especial eligible modal-anno-domini-eligible ${
        isMobile ? "mobile" : "web"
      }`}
    >
      <>
        <div
          style={{
            position: "relative",
          }}
        >
          <div
            className={`conteudo conteudo-anno-domini ${
              isMobile ? "mobile" : "web"
            }`}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: `linear-gradient(180deg, rgba(25, 25, 25, 0.1) 0%, #3F3DB3 100%), url(${imgAnnoDominiWeb}) no-repeat top center`,
              backgroundSize: "cover",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={imgAnnoDominiLogo}
                alt="Anno Domini Logo"
                className="anno-domini-logo"
                style={{
                  opacity: 0.5,
                  position: "absolute",
                  top: 0,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1,
              }}
            >
              <span className="chamada">
                {t("pages.CampanhasEspeciais.AnnoDomini.quaseLa")}
              </span>
              <h1 className="titulo">
                <Trans i18nKey="pages.CampanhasEspeciais.AnnoDomini.temosUmBeneficio" />
              </h1>
              <span>
                {t("pages.CampanhasEspeciais.AnnoDomini.adiantamentoEstimado")}
              </span>
              <p className="valor linha-paragrafo">
                <b>
                  {signByCurrency(userArtist?.cashAdvanceEstimated?.currency)}
                </b>
                {formatNoSignObject(userArtist?.cashAdvanceEstimated)}
              </p>
              <span className="divider" />
              <ul>
                <li className="circle-checkmark azul">
                  {t(
                    "pages.CampanhasEspeciais.AnnoDomini.annoDominiBeneficio1"
                  )}
                </li>
                <li className="circle-checkmark azul">
                  {t(
                    "pages.CampanhasEspeciais.AnnoDomini.annoDominiBeneficio2"
                  )}
                </li>
                <li className="circle-checkmark azul">
                  {t(
                    "pages.CampanhasEspeciais.AnnoDomini.annoDominiBeneficio3"
                  )}
                </li>
              </ul>
              <div className="buttons" style={{ gap: "20px" }}>
                <button
                  className="botao-roxo"
                  style={{
                    minWidth: "270px",
                    backgroundColor: "#F2F2F2",
                    color: "#111833",
                  }}
                  onClick={acceptWithAdvance}
                >
                  {t("pages.CampanhasEspeciais.queroSolicitar")}
                </button>
                <button className="botao-link" onClick={acceptWithoutAdvance}>
                  {t("pages.CampanhasEspeciais.continuarSemAdiantamento")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default ModalCampaignADEligible;
